import { BPMNProcess } from "../types";

const DEFAULT_DURATION = 20;

export function getOrder(json: BPMNProcess) {
  const order: string[] = [];

  function getPath(id: string, order: string[]) {
    if(order.includes(id)) {
      return
    }

    order.push(id);
    const info = json[id];

    if (!info) {
      return;
    }

    if (info.type === "endEvent") {
      return;
    }

    const nextIds =
      info.type === "sequenceFlow"
        ? [info.targetRef]
        : Array.isArray(info.outgoing)
        ? info.outgoing
        : [info.outgoing];

    nextIds.forEach((id) => {
      if(id) {
        getPath(id, order)
      }
    });
  }

  const startNode = Object.keys(json).find(
    (key) => json[key].type === "startEvent"
  );

  if (startNode) {
    getPath(startNode, order);
  }

  return order;
}

export function setScenarizeData(
  node: SVGElement,
  json: BPMNProcess
) {
  const order: string[] = [];
  let startCounter = 0;

  function getPathAndSetAttributes(id: string, order: string[]) {
    if(order.includes(id)) {
      return
    }

    order.push(id);
    const info = json[id];

    if (!info) {
      return;
    }

    const path = getPath(node, id, info.type === "sequenceFlow");

    if (path) {
      setAttributes(path, startCounter);
      startCounter += DEFAULT_DURATION;
    }

    if (info.type === "endEvent") {
      return;
    }

    const nextIds =
      info.type === "sequenceFlow"
        ? [info.targetRef]
        : Array.isArray(info.outgoing)
        ? info.outgoing
        : [info.outgoing];

    nextIds.forEach((id) => {
      if(id) {
        getPathAndSetAttributes(id, order)
      }
    });
  }

  const startNodes = Object.keys(json).filter(
    (key) => json[key].type === "startEvent"
  );

  if (startNodes) {
    startNodes.forEach(node => getPathAndSetAttributes(node, order))
  }

  return order;
}

function getPath(node: SVGElement, id: string, isConnection = false) {
  const selector = isConnection ? ".djs-connection" : ".djs-shape";
  const visualNode = node.querySelector(
    `.djs-element${selector}[data-element-id="${id}"] .djs-visual`
  );

  let path: HTMLElement | null = null;
  if (visualNode) {
    path = visualNode.querySelector(
      "path, rect, circle, ellipse, line, polyline, polygon"
    );
  }

  return path;
}

function setAttributes(path: HTMLElement, start: number) {
  path.setAttribute("data-start", start.toString());
  path.setAttribute("data-duration", DEFAULT_DURATION.toString());
}
